/* istanbul ignore file */
export { BoxComponentsModule } from './box-components.module';
export * from './box.component';
